class ComparisonSliderComponent extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement | null} */
    this.media = null;
    /** @type {HTMLInputElement | null} */
    this.slider = null;
    /** @type {IntersectionObserver | null} */
    this.observer = null;
    this.hasAnimated = false;
    this.isAnimating = false;
  }

  connectedCallback() {
    this.media = /** @type {HTMLElement | null} */ (this.querySelector('[data-comparison-media]'));
    this.slider = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-comparison-range]'));

    if (!this.media || !this.slider) return;

    this.handleInput = this.handleInput.bind(this);
    this.slider.addEventListener('input', this.handleInput);
    this.slider.addEventListener('change', this.handleInput);

    this.sync();
    this.setupHintAnimation();
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.removeEventListener('input', this.handleInput);
      this.slider.removeEventListener('change', this.handleInput);
    }
    if (this.observer) this.observer.disconnect();
  }

  handleInput() {
    if (this.isAnimating) return;
    this.sync();
  }

  sync() {
    if (!this.media || !this.slider) return;

    const min = Number(this.slider.min) || 0;
    const max = Number(this.slider.max) || 100;
    const value = Number(this.slider.value);
    const percent = Math.round(((value - min) / (max - min)) * 100);
    this.media.style.setProperty('--compare', String(percent));
  }

  setupHintAnimation() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.runHintAnimation();
            if (this.observer) this.observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );
    this.observer.observe(this);
  }

  runHintAnimation() {
    if (!this.media || !this.slider) return;

    this.isAnimating = true;
    this.media.style.setProperty('--transition-duration', '0.6s');

    const steps = [
      { value: 38, delay: 150 },
      { value: 62, delay: 750 },
      { value: 50, delay: 1350 },
    ];

    steps.forEach(({ value, delay }) => {
      setTimeout(() => {
        if (this.media) this.media.style.setProperty('--compare', String(value));
      }, delay);
    });

    setTimeout(() => {
      if (this.media) this.media.style.setProperty('--transition-duration', '0s');
      if (this.slider) this.slider.value = '50';
      this.isAnimating = false;
    }, 2000);
  }
}

if (!customElements.get('comparison-slider-component')) {
  customElements.define('comparison-slider-component', ComparisonSliderComponent);
}
